import { User } from 'src/app/_types/auth.types';
import { CustomerState } from 'src/app/enums/customer-state.enum';

/**
 * Whether account mails reach this customer. Communicator withholds them from an account without a
 * password, or one that is inactive or blocked (`CommunicationServiceImpl.isEligibleUser`). Null
 * while the customer is unknown, so the caller keeps offering « Sans notification ».
 */
export function receivesAccountMail(
  customer: User | null | undefined
): boolean | null {
  if (!customer) {
    return null;
  }
  return (
    !!customer.hasPassword &&
    customer.userState !== CustomerState.INACTIVE &&
    customer.userState !== CustomerState.BLOCKED
  );
}
